import { getSiteUrl } from './seo';

export interface ArticleLike {
  title: string;
  excerpt: string;
  updatedDate: string;
}

export function buildWebSiteSchema(): Record<string, unknown> {
  const url = getSiteUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'AllChinaBuy Spreadsheet',
    url: `${url}/`,
    description:
      'Independent informational resource for AllChinaBuy spreadsheet, product guides, seller research, and buying tips.',
  };
}

export function buildOrganizationSchema(): Record<string, unknown> {
  const url = getSiteUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AllChinaBuy Spreadsheet',
    url: `${url}/`,
  };
}

export function buildArticleSchema(
  article: ArticleLike,
  canonical: string
): Record<string, unknown> {
  const url = getSiteUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    datePublished: article.updatedDate,
    dateModified: article.updatedDate,
    author: { '@type': 'Organization', name: 'AllChinaBuy Spreadsheet', url: `${url}/` },
    publisher: { '@type': 'Organization', name: 'AllChinaBuy Spreadsheet', url: `${url}/` },
    mainEntityOfPage: { '@type': 'WebPage', '@id': canonical },
  };
}

export function buildBreadcrumbSchema(
  items: { name: string; item: string }[]
): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
}

export function injectJsonLd(id: string, data: Record<string, unknown>): void {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id: string): void {
  const el = document.getElementById(id);
  if (el) el.remove();
}